import { SVGAttributes, useContext } from 'react';
import { ThemeContext } from 'styled-components';

export default function (props: SVGAttributes<SVGElement>) {
    const themeContext = useContext(ThemeContext);

    return (
        <svg {...props} width="7" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 16">
            <g fill="none" fillRule="evenodd">
                <g transform="translate(-18 -16)">
                    <path stroke={themeContext.colors.primary['90']} strokeWidth="1.6" d="M26.4 16.8L19.2 24l7.2 7.2" />
                </g>
            </g>
        </svg>
    );
}
